// extracted by mini-css-extract-plugin
export default {"business_card__body":"business-card-body_business_card__body__wDj4A","title":"business-card-body_title__+ej6c","row_icon":"business-card-body_row_icon__yqdT6"};